module.exports = __webpack_public_path__ + "static/media/whatsapp.1ee79d4e.svg";